export default "__VITE_ASSET__DKEX6$qL__"